module.exports = __webpack_public_path__ + "img/ver6.781e6fa7.jpg";